import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { CartProvider } from "@/contexts/CartContext";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Esencia from "@/components/site/Esencia";
import Platos from "@/components/site/Platos";
import Reviews from "@/components/site/Reviews";
import Servicios from "@/components/site/Servicios";
import Footer from "@/components/site/Footer";
import Carta from "@/components/site/Carta";
import Tienda from "@/components/site/Tienda";
import CartDrawer from "@/components/site/CartDrawer";
import CheckoutPage from "@/pages/CheckoutPage";
import PaymentResultPage from "@/pages/PaymentResultPage";

function Landing() {
  return (
    <div className="App" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Esencia />
        <Platos />
        <Carta />
        <Tienda />
        <Reviews />
        <Servicios />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}

function CheckoutLayout() {
  return (
    <>
      <CheckoutPage />
      <CartDrawer />
    </>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/checkout" element={<CheckoutLayout />} />
            <Route
              path="/pago-exitoso"
              element={<PaymentResultPage outcome="success" />}
            />
            <Route
              path="/pago-fallido"
              element={<PaymentResultPage outcome="failure" />}
            />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              color: "#F9F6F0",
              border: "1px solid #3a3a3a",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </CartProvider>
    </LanguageProvider>
  );
}
